import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateUserPin = {
  name: "updateUserPin" as const,
  input: z.object({
    userId: zExt.objectId(),
    pin: z.string().regex(/^\d{4}$/),
  }),
  output: z.object({ pin: z.string() }),
};
